import React from 'react';
import PropTypes from 'prop-types';
import createOpenGraphTags from '@repo/utils/createOpenGraphTags';
import Breadcrumb from '@components/breadcrumb';
import Layout from '@components/layout';
import BlogArticle from '@components/articles/BlogArticle';
import RecentArticles from '@components/articles/RecentArticles';
import { styles } from '@components/utils';
import KurgoContainer from '@components/utils/ContainerStyles';

const ArticleDetail = ({ pageContext }) => {
  const { article, breadcrumbs } = pageContext;

  const openGraphData = {
    type: 'article',
    title: `${article?.title} - Kurgo Dog Products`,
    description: article?.excerpt,
    url: `/blog/${article?.handle}`,
    image: article.image.url,
    article: {
      published_time: article?.publishedAt,
      author: article?.authorV2?.name,
      tag: article?.tags,
    },
  };

  return (
    <Layout
      headTagData={{
        title: `${article?.title} - Kurgo Dog Products`,
        description: article?.excerpt,
        meta: createOpenGraphTags(openGraphData, 'kurgo'),
      }}
    >
      <KurgoContainer backgroundColor={styles.colors.gray[100]}>
        {breadcrumbs && <Breadcrumb elements={breadcrumbs} />}
        <BlogArticle article={article} />
        <RecentArticles />
      </KurgoContainer>
    </Layout>
  );
};

ArticleDetail.propTypes = {
  pageContext: PropTypes.shape({
    article: PropTypes.shape({
      title: PropTypes.string,
      image: PropTypes.shape({
        altText: PropTypes.string,
        url: PropTypes.string,
      }),
      authorV2: PropTypes.shape({
        name: PropTypes.string,
      }),
      publishedAt: PropTypes.string,
      contentHtml: PropTypes.string,
      tags: PropTypes.arrayOf(PropTypes.string),
      excerpt: PropTypes.string,
      handle: PropTypes.string,
    }),
    breadcrumbs: PropTypes.arrayOf(PropTypes.shape({})),
  }).isRequired,
};

export default ArticleDetail;
